import SnippetIcon from '@/components/atom/icon/search/SnippetIcon';

interface Props {
  keyword: string;
}

const FaceToFacePrescriptionSnippet = ({ keyword }: Props) => {
  return (
    <div className='border-0 border-b-[16px] border-b-gray-30 border-solid p-[28px_20px]'>
      <div className={'px-[4px]'}>
        <div className={'flex flex-col gap-[8px]'}>
          <SnippetIcon />
          <span className={'typography-ui-24b whitespace-pre text-gray-900'}>
            <span className={'text-primary-700'}>{keyword}</span> 처방,{'\n'}병원 방문이 필요해요!
          </span>
          <span className={'typography-ui-15r whitespace-pre text-gray-400'}>
            비대면 처방이 어려운 의약품이 처방될 수 있어{'\n'}병원 방문을 통한 대면 진료가 필요해요.
          </span>
        </div>
      </div>
    </div>
  );
};

export default FaceToFacePrescriptionSnippet;
